import React from "react";
import { CircularProgress } from "@mui/material";

function Loading() {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress sx={{ color: "#012169" }} />
    </div>
  );
}

export default Loading;
